import { editorClient } from "@/lib/editorClient";
import { LanguageKey } from "@op/puck-types";

export async function getLanguageTopics(
  organizationSlug: string,
  projectSlug: string,
  languageKey: LanguageKey
) {
  const res = await editorClient.languages[":organizationSlug"][":projectSlug"][
    ":languageKey"
  ].topics.$get({
    param: {
      organizationSlug,
      projectSlug,
      languageKey,
    },
  });
  const data = await res.json();
  return data;
}
